import { Navigate } from 'react-router-dom';

import { useOrganization } from '@/hooks/useOrganization';
import { useAuth } from '@/lib/auth';

interface OnboardingCheckProps {
  children: React.ReactNode;
}

/**
 * OnboardingCheck redirects users to organization onboarding if they don't have an organization.
 * This ensures all users have an organization context before accessing the app.
 */
export function OnboardingCheck({ children }: OnboardingCheckProps) {
  const { user, loading: authLoading } = useAuth();
  const { organizations, loading: orgLoading } = useOrganization();

  console.log('[OnboardingCheck] authLoading:', authLoading, 'orgLoading:', orgLoading, 'user:', user?.email, 'orgs:', organizations.length);

  // Wait for auth and org data to load
  if (authLoading || orgLoading) {
    console.log('[OnboardingCheck] Showing loading spinner (authLoading:', authLoading, 'orgLoading:', orgLoading, ')');
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin text-4xl mb-4">🌿</div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // If no user, ProtectedRoute handles redirect to login
  if (!user) {
    console.log('[OnboardingCheck] No user, letting ProtectedRoute handle');
    return <>{children}</>;
  }

  // If user has no organizations, redirect to onboarding
  if (organizations.length === 0) {
    console.log('[OnboardingCheck] No organizations, redirecting to /onboarding/organization');
    return <Navigate to="/onboarding/organization" replace />;
  }

  console.log('[OnboardingCheck] User has', organizations.length, 'organizations, rendering children');
  return <>{children}</>;
}